export { MdSettings as IconSettings } from "react-icons/md";
